// Strength tiers as reported by the backend analyzer, weakest first.
// `rank` drives the segmented meter; the class names map to the
// `tier` color scale in tailwind.config.js.
export const STRENGTH_TIERS = {
  very_weak:   { rank: 1, label: 'Very weak',   text: 'text-tier-1', bar: 'bg-tier-1' },
  weak:        { rank: 2, label: 'Weak',        text: 'text-tier-2', bar: 'bg-tier-2' },
  moderate:    { rank: 3, label: 'Moderate',    text: 'text-tier-3', bar: 'bg-tier-3' },
  strong:      { rank: 4, label: 'Strong',      text: 'text-tier-4', bar: 'bg-tier-4' },
  very_strong: { rank: 5, label: 'Very strong', text: 'text-tier-5', bar: 'bg-tier-5' },
}

export function getTier(strength) {
  return STRENGTH_TIERS[strength] ?? STRENGTH_TIERS.very_weak
}

export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    // Clipboard API needs a secure context; fall back to execCommand
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed'
    textArea.style.left = '-9999px'
    document.body.appendChild(textArea)
    textArea.select()
    try {
      document.execCommand('copy')
      return true
    } catch {
      return false
    } finally {
      document.body.removeChild(textArea)
    }
  }
}

export function formatNumber(num) {
  if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + 'M'
  if (num >= 1_000) return (num / 1_000).toFixed(1) + 'K'
  return String(num)
}
